// extracted by mini-css-extract-plugin
export default {"button":"link-login_button__hhlAV"};